// extracted by mini-css-extract-plugin
export default {"modalTitle":"UserSettingsModal_modalTitle__OQay0"};